// import logo from './logo.svg';
import './App.css';
import { useState } from 'react';
import Navbar from './Components/navbar';
import Myform from './Components/text-form';
// import About from './Components/about';
import Alert from './Components/alert';

// import * as React from "react";
// import {
//   BrowserRouter,
//   // RouterProvider,
//   Route,
//   Routes,
//   // Link,
// } from "react-router-dom";


function App() {
  const [light,dark] = useState({
    backgroundColor:"white",
    color:"black",
  })

  const [alert,setalert] = useState(null);

  let showalert = (message,type) => {
      setalert({
        msg:message,
        type:type
      })

      setTimeout(() => {
        setalert(null)
      }, 3000);
  }
  
  let darkModeEnable = () => {
  
    if (light.color === "black"){
      dark({
        backgroundColor:"black",
        color:"white",
        
      })
      let textarea = document.getElementById('textarea');
      if (textarea){
    textarea.style.border = "2px solid white";  
      document.body.style.backgroundColor = "black"
      document.body.style.color = "white"
      showalert("Dark mode has been enabled!","dark")
      }
    }
    else{
      dark({
        backgroundColor:"white",
        color:"black",
      })  
      let textarea = document.getElementById('textarea');
      if (textarea){
    textarea.style.border = "2px solid black";
    textarea.classList.remove('textareaPlaceholder');
      document.body.style.backgroundColor = "white"
      document.body.style.color = "black"
      showalert("Light mode has been enabled!","light")
      }
    }
  
    }

  const purpleModeEnable = () => {
    dark({
      backgroundColor:"#481eb5",
      color:"white",
    })  
    let textarea = document.getElementById('textarea');
    if (textarea){
    textarea.style.border = "2px solid white";
    textarea.classList.add('textareaPlaceholder');
    document.body.style.backgroundColor = "#481eb5"
      document.body.style.color = "white"
      showalert("Purple mode has been enabled!","info")
    }
  }
  const blueModeEnable = () => {
    dark({
      backgroundColor:"#19118b",
      color:"white",
    })  
    document.body.style.backgroundColor = "#19118b"
      document.body.style.color = "white"
    let textarea = document.getElementById('textarea');
    if (textarea){
    textarea.style.border = "2px solid white";
    textarea.classList.add('textareaPlaceholder');
      showalert("Blue mode has been enabled!","info")
    }
  }
  const greenModeEnable = () => {
    dark({
      backgroundColor:"#086a01",
      color:"white",
    })  
    let textarea = document.getElementById('textarea');
    document.body.style.backgroundColor = "#086a01"
      document.body.style.color = "white"
    if(textarea){
    textarea.style.border = "2px solid white";
    textarea.classList.add('textareaPlaceholder');
      showalert("Green mode has been enabled!","info")
    }
  }
  const orangeModeEnable = () => {
    dark({
      backgroundColor:"#7a590e",
      color:"white",
    })  
    let textarea = document.getElementById('textarea');
    document.body.style.backgroundColor = "#7a590e"
    document.body.style.color = "white"
    if(textarea){
    textarea.classList.add('textareaPlaceholder');
    textarea.style.border = "2px solid white";
      showalert("Orange mode has been enabled!","info")
    }
  }



  
  return (
    // <BrowserRouter>
    <>
  <Navbar light={light} darkModeEnable={darkModeEnable} purpleModeEnable={purpleModeEnable} blueModeEnable={blueModeEnable} greenModeEnable={greenModeEnable} orangeModeEnable={orangeModeEnable}></Navbar>
  <Alert alert={alert}/>
    
  {/* <Routes>
        <Route
          path="/"
          element={ */}
            <Myform light={light} showalert={showalert}></Myform>
          {/* } */}
        {/* /> */}
        {/* <Route
          path="/about"
          element={ */}
          {/* <About light={light} showalert={showalert}></About> */}
        {/* }
        />
    </Routes> */}

  </>
    // {/* </BrowserRouter> */}
  );
}

export default App;

